import { render } from "./legup-waitlist.vue?vue&type=template&id=7a10d02c&scoped=true"
import script from "./legup-waitlist.vue?vue&type=script&lang=js"
export * from "./legup-waitlist.vue?vue&type=script&lang=js"

import "./legup-waitlist.vue?vue&type=style&index=0&id=7a10d02c&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a10d02c"]])

export default __exports__